<template>
  <div>
    <button
      id="carousel-control-prev"
      type="button"
      :class="{
        'carousel-control-prev': true,
      }"
    >
      <PtcIcon
        name="ptc-arrow-carousel-control"
        :class="{
          'text-[46px] text-www-color-primary-lighter': true,
        }"
        alt="ptc-arrow-carousel-control"
      />
    </button>

    <button
      id="carousel-control-next"
      type="button"
      :class="{
        'carousel-control-next rotate-180': true,
      }"
    >
      <PtcIcon
        name="ptc-arrow-carousel-control"
        :class="{
          'text-[46px] text-www-color-primary-lighter': true,
        }"
        alt="ptc-arrow-carousel-control"
      />
    </button>
  </div>
</template>

<script lang="ts" setup>
import PtcIcon from '~/components/Atoms/PtcIcon/PtcIcon.vue';
</script>
